module.exports = __webpack_public_path__ + "img/16.8cc16f59.jpg";